import { useRouter } from 'next/router';

import BANNER_OPTIONS from '../../utils/bannerOptions';

import styles from './SortingOptions.module.scss';

export default function SortingOptions({ showBySelection, onChange }) {
  const router = useRouter();

  return (
    <select className={styles.select} value={showBySelection} onChange={onChange}>
      {!router.asPath.includes('/search') && <option value={BANNER_OPTIONS.catalog}>Προεπιλογή</option>}
      {router.asPath.includes('/search') && <option value={BANNER_OPTIONS.catalog}>Συνάφεια</option>}
      {!router.asPath.includes('/offer') && !router.asPath.includes('/smart') && (
        <option value={BANNER_OPTIONS.offer}>Προσφορές</option>
      )}
      <option value={BANNER_OPTIONS.alphabetical}>Αλφαβητικά</option>
      <option value={BANNER_OPTIONS.expensive}>Ακριβό -&gt; Φτηνό</option>
      <option value={BANNER_OPTIONS.cheap}>Φτηνό -&gt; Ακριβό</option>
      {!router.asPath.includes('/offer') && !router.asPath.includes('/smart') && (
        <option value={BANNER_OPTIONS.kiloPrice}>Τιμή κιλού</option>
      )}
    </select>
  );
}
